import { render, staticRenderFns } from "./SurveyManagementPreviewTextInputQuestion.vue?vue&type=template&id=36b91687&scoped=true&"
import script from "./SurveyManagementPreviewTextInputQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementPreviewTextInputQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementPreviewTextInputQuestion.vue?vue&type=style&index=0&id=36b91687&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b91687",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b91687')) {
      api.createRecord('36b91687', component.options)
    } else {
      api.reload('36b91687', component.options)
    }
    module.hot.accept("./SurveyManagementPreviewTextInputQuestion.vue?vue&type=template&id=36b91687&scoped=true&", function () {
      api.rerender('36b91687', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/question-preview/SurveyManagementPreviewTextInputQuestion.vue"
export default component.exports